export default __webpack_public_path__ + "static/media/battery.e68eae4b.svg";